function AudioPlayer(){
    var audioContext;
    var acZERO = 0.000001;

    try {
        // Fix up for prefixing
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        audioContext = new AudioContext();
    }
    catch (e) {
        alert('Web Audio API is not supported in this browser');
    }

    this.sounds = [];

    this.loadSound = function(name, url, onLoaded) {
        var sound = new Object();
        sound.name = name;
        sound.url = url;
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';

        request.onload = function () {
            audioContext.decodeAudioData(request.response, function (buffer) {
                sound.buffer = buffer;
                sound.source = audioContext.createBufferSource();
                sound.source.buffer = sound.buffer;
                sound.gain = audioContext.createGain();
                sound.source.connect(sound.gain);
                sound.gain.connect(audioContext.destination);
                onLoaded(sound);
            });
        }
        request.send();
        this.sounds.push(sound);
        return sound;
    }
    this.play = function(sound, offset, loop) {
        sound.source.loop = loop;
        sound.source.start(0, offset);
    }
    this.setGain = function(sound, gainValue) {
        gainValue = this.clampGain(gainValue);
        sound.gain.gain.setValueAtTime(gainValue, audioContext.currentTime);
    }
    this.fadeTo = function(sound, gainValue, fadeLength) {
        gainValue = this.clampGain(gainValue);
        sound.gain.gain.setValueAtTime(sound.gain.gain.value, audioContext.currentTime);
        sound.gain.gain.linearRampToValueAtTime(gainValue, audioContext.currentTime + fadeLength);
    }
    this.getSoundByName = function(soundName) {
        for(var i = 0; i < this.sounds.length; i++){
            if(this.sounds[i].name == soundName){
                return this.sounds[i];
            }
        }
        return null;
    }
    this.clampGain = function(value){
        return Math.max(acZERO, Math.min(value, 1));
    }
}